import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { GeoPos } from '../core/geographicalpos/geographicalpos.model';
import { GeoPosActionService } from '../core/geographicalpos/geographicalpos.action';

@Injectable()
export class GeoPosResolver implements Resolve<GeoPos[]> {
  @select(['geopos', 'list'])
  geoposList$: Observable<GeoPos[]>;
  isGeoPosInRedux = false;

  constructor(private service: ApiService,
              private geoposAction: GeoPosActionService) {}

  resolve() {
    return this.geoposList$.pipe(
      first(),
      mergeMap((list) => {
        if (list.length > 0) {
          this.isGeoPosInRedux = true;
          return of(list);
        }
        return this.service.getGeoPos().pipe(first());
      }),
      tap((list: any) => {
        if (!this.isGeoPosInRedux) {
          this.geoposAction.geoposList(GeoPos.fromArray(list));
        }
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di aree');
        return of(err);
      })
    );
  }
}
